import './AurigaError.scss';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ErrorProps } from 'types/Common.types';

const ERROR_CLASS_NAME = 'generic-error-message ';
const ERROR_TITLE = 'Error';
const ERROR_MESSAGE = 'An error has occurred. Please try again.';

const AurigaError = (props: ErrorProps) => {
  return (
    <Box className={props.className || ERROR_CLASS_NAME}>
      <Typography variant='h4'>{props.title || ERROR_TITLE}</Typography>
      <Typography variant='h6'>{props.errorMessage || ERROR_MESSAGE}</Typography>
    </Box>
  );
};

export default AurigaError;
